import { Breadcrumb, BreadcrumbIcon, BreadcrumbLink, BreadcrumbPage } from '@ads/components-react';
import { Link } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface PersonListTemplateProps {
  readonly headerActions: ReactNode;
  readonly filterPanel: ReactNode;
  readonly table: ReactNode;
}

export function PersonListTemplate({ headerActions, filterPanel, table }: PersonListTemplateProps) {
  const { t } = useTranslation('personManagement');

  return (
    <div className="flex flex-col gap-nano">
      <Breadcrumb>
        <BreadcrumbLink>
          <Link to="/">
            <BreadcrumbIcon />
          </Link>
        </BreadcrumbLink>
        <BreadcrumbPage>{t('breadcrumb.persons')}</BreadcrumbPage>
      </Breadcrumb>

      <div className="flex items-center justify-between">
        <div className="flex flex-col gap-nano">
          <h1 className="ts-heading-lg text-ctx-content-title">{t('personList.title')}</h1>
          <p className="ts-paragraph-xs text-ctx-content-title">{t('personList.subtitle')}</p>
        </div>
        {headerActions}
      </div>

      <div className="rounded-md  my-xxs border-hairline border-ctx-layout-border bg-ctx-layout-surface p-xxs shadow-level1">
        {filterPanel}
      </div>

      <div className="overflow-hidden rounded-md border-hairline border-ctx-layout-border bg-ctx-layout-surface shadow-level1">
        {table}
      </div>
    </div>
  );
}
